import React from 'react';

export const DropdownExpandIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.92297 2.88116C5.26468 2.53945 5.8187 2.53945 6.16041 2.88116L9.66041 6.38116C10.0021 6.72287 10.0021 7.27688 9.66041 7.61859L6.16044 11.1186C5.81873 11.4603 5.26471 11.4603 4.923 11.1186C4.58129 10.7769 4.58129 10.2229 4.92299 9.88116L7.80425 6.99988L4.92297 4.1186C4.58126 3.77689 4.58126 3.22287 4.92297 2.88116Z"
      fill="#7A7E8B"
    />
  </svg>
);

export const GoogleIcon = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_172_10444)">
      <path
        d="M6.13625 10C6.13625 9.52378 6.2175 9.06691 6.36125 8.63878L3.8375 6.75128C3.33044 7.75908 3.06712 8.87186 3.06875 10C3.06875 11.1675 3.345 12.2688 3.83625 13.2463L6.35875 11.3557C6.21167 10.9188 6.13652 10.461 6.13625 10Z"
        fill="#FBBC05"
      />
      <path
        d="M10.5687 5.66687C11.625 5.66687 12.5794 6.03312 13.3294 6.63312L15.5112 4.5C14.1819 3.36687 12.4775 2.66687 10.5687 2.66687C7.605 2.66687 5.0575 4.32625 3.8375 6.75125L6.3625 8.63875C6.94375 6.91 8.60125 5.66687 10.5687 5.66687Z"
        fill="#EA4335"
      />
      <path
        d="M10.5688 14.3331C8.60063 14.3331 6.94313 13.09 6.36125 11.3613L3.8375 13.2488C5.05687 15.6738 7.60438 17.3331 10.5688 17.3331C12.3975 17.3331 14.1438 16.6975 15.455 15.5056L13.0588 13.6919C12.3831 14.1088 11.5319 14.3331 10.5681 14.3331"
        fill="#34A853"
      />
      <path
        d="M17.7275 9.99999C17.7275 9.56687 17.6587 9.1 17.5569 8.66687H10.5681V11.5H14.5906C14.39 12.4662 13.8425 13.2087 13.0594 13.6919L15.455 15.5056C16.8319 14.2544 17.7275 12.3906 17.7275 9.99999Z"
        fill="#4285F4"
      />
    </g>
    <defs>
      <clipPath id="clip0_172_10444">
        <rect width="15" height="15" fill="white" transform="translate(3 2.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const ModelCloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M3.51817 3.51797C3.8436 3.19253 4.37124 3.19253 4.69668 3.51797L16.4818 15.3031C16.8072 15.6285 16.8072 16.1562 16.4818 16.4816C16.1564 16.807 15.6287 16.807 15.3033 16.4816L3.51817 4.69648C3.19273 4.37104 3.19273 3.8434 3.51817 3.51797Z"
      fill="currentColor"
    />
    <path
      d="M16.4811 3.51817C16.8065 3.8436 16.8065 4.37124 16.4811 4.69667L4.69594 16.4818C4.3705 16.8072 3.84287 16.8072 3.51743 16.4818C3.19199 16.1564 3.192 15.6287 3.51743 15.3033L15.3025 3.51817C15.628 3.19273 16.1556 3.19273 16.4811 3.51817Z"
      fill="currentColor"
    />
  </svg>
);

export const ListArrowDown = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5303 8.46967C13.8232 8.76256 13.8232 9.23744 13.5303 9.53033L10.5303 12.5303C10.2374 12.8232 9.76257 12.8232 9.46967 12.5303L6.46967 9.53036C6.17678 9.23746 6.17678 8.76259 6.46967 8.4697C6.76256 8.1768 7.23743 8.1768 7.53033 8.46969L10 10.9393L12.4697 8.46967C12.7626 8.17678 13.2374 8.17678 13.5303 8.46967Z"
      fill="#7A7E8B"
    />
  </svg>
);

export const CheckboxCheckedIcon = () => (
  <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7" cy="7.5" r="7" fill="var(--col_brand00)" />
    <rect
      x="3.28961"
      y="7.18945"
      width="1.75"
      height="4.375"
      rx="0.875"
      transform="rotate(-45 3.28961 7.18945)"
      fill="var(--col_text05)"
    />
    <rect
      x="9.47614"
      y="4.71484"
      width="1.75"
      height="6.125"
      rx="0.875"
      transform="rotate(45 9.47614 4.71484)"
      fill="var(--col_text05)"
    />
  </svg>
);

export const CheckboxUncheckedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 12.75C9.8995 12.75 12.25 10.3995 12.25 7.5C12.25 4.60051 9.8995 2.25 7 2.25C4.10051 2.25 1.75 4.60051 1.75 7.5C1.75 10.3995 4.10051 12.75 7 12.75ZM7 14.5C10.866 14.5 14 11.366 14 7.5C14 3.63401 10.866 0.5 7 0.5C3.13401 0.5 0 3.63401 0 7.5C0 11.366 3.13401 14.5 7 14.5Z"
      fill="currentColor"
    />
  </svg>
);

export const CountrySearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Frame 1912054802">
      <path
        id="Vector 3262 (Stroke)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7071 5.62627C13.0976 6.01679 13.0976 6.64996 12.7071 7.04048L8.70711 11.0405C8.31658 11.431 7.68342 11.431 7.2929 11.0405L3.2929 7.04052C2.90237 6.64999 2.90237 6.01683 3.29289 5.6263C3.68341 5.23578 4.31658 5.23577 4.7071 5.6263L8 8.91916L11.2929 5.62627C11.6834 5.23574 12.3166 5.23574 12.7071 5.62627Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const SelectedCountryCheckIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="country-check-icon mr-4 hidden"
  >
    <g id="icon/Tool_selected">
      <path
        id="Union"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6999 7.0992C18.0904 6.70867 18.0904 6.07551 17.6999 5.68498C17.3094 5.29446 16.6762 5.29446 16.2857 5.68498L8.88543 13.0852L6.20748 10.4075C5.817 10.017 5.18393 10.017 4.79347 10.4075C4.40298 10.798 4.40299 11.4311 4.7935 11.8216L8.16522 15.193C8.16956 15.1975 8.17396 15.202 8.17841 15.2065C8.56894 15.597 9.2021 15.597 9.59263 15.2065L17.6999 7.0992Z"
        fill="var(--col_brand00)"
      />
    </g>
  </svg>
);

export const ContactCopyIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.9165 8.3335C2.9165 6.95278 4.03579 5.8335 5.4165 5.8335H11.2498C12.6305 5.8335 13.7498 6.95278 13.7498 8.3335V15.4168C13.7498 16.7975 12.6305 17.9168 11.2498 17.9168H5.4165C4.03579 17.9168 2.9165 16.7975 2.9165 15.4168V8.3335ZM5.4165 7.50016C4.95627 7.50016 4.58317 7.87326 4.58317 8.3335V15.4168C4.58317 15.8771 4.95627 16.2502 5.4165 16.2502H11.2498C11.7101 16.2502 12.0832 15.8771 12.0832 15.4168V8.3335C12.0832 7.87326 11.7101 7.50016 11.2498 7.50016H5.4165Z"
      fill="#7A7E8B"
    />
    <path
      d="M6.25 4.5835C6.25 3.20278 7.36929 2.0835 8.75 2.0835H14.5833C15.964 2.0835 17.0833 3.20278 17.0833 4.5835V11.6668C17.0833 13.0475 15.964 14.1668 14.5833 14.1668H12.9167V12.5002H14.5833C15.0436 12.5002 15.4167 12.1271 15.4167 11.6668V4.5835C15.4167 4.12326 15.0436 3.75016 14.5833 3.75016H8.75C8.28976 3.75016 7.91667 4.12326 7.91667 4.5835V6.66683H6.25V4.5835Z"
      fill="#7A7E8B"
    />
  </svg>
);

export const ContactLinkIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2323 8.11103C11.7944 6.54893 14.3271 6.54893 15.8892 8.11103C17.4513 9.67312 17.4513 12.2058 15.8892 13.7679C15.4987 14.1584 14.8655 14.1584 14.475 13.7679C14.0845 13.3774 14.0845 12.7442 14.475 12.3537C15.256 11.5726 15.256 10.3063 14.475 9.52524C13.6939 8.74419 12.4276 8.74419 11.6466 9.52524C11.256 9.91576 10.6229 9.91576 10.2323 9.52524C9.84182 9.13472 9.84182 8.50155 10.2323 8.11103ZM9.52524 10.2323C9.91576 10.6229 9.91576 11.256 9.52524 11.6466C8.74419 12.4276 8.74419 13.6939 9.52524 14.475C10.3063 15.256 11.5726 15.256 12.3537 14.475C12.7442 14.0845 13.3774 14.0845 13.7679 14.475C14.1584 14.8655 14.1584 15.4987 13.7679 15.8892C12.2058 17.4513 9.67312 17.4513 8.11103 15.8892C6.54893 14.3271 6.54893 11.7944 8.11103 10.2323C8.50155 9.84182 9.13472 9.84182 9.52524 10.2323Z"
      fill="#14151A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4143 10.5859C13.8049 10.9764 13.8049 11.6096 13.4143 12.0001L12.0001 13.4143C11.6096 13.8049 10.9764 13.8049 10.5859 13.4143C10.1954 13.0238 10.1954 12.3906 10.5859 12.0001L12.0001 10.5859C12.3906 10.1954 13.0238 10.1954 13.4143 10.5859Z"
      fill="#14151A"
    />
  </svg>
);

export const ModalCloseIcon = () => (
  <svg
    className="md:text-col_text00 text-col_text02 h-4 w-4 md:h-6 md:w-6"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.22185 4.22273C4.61237 3.83221 5.24554 3.83221 5.63606 4.22273L19.7782 18.3649C20.1687 18.7554 20.1687 19.3886 19.7782 19.7791C19.3877 20.1696 18.7545 20.1696 18.364 19.7791L4.22185 5.63695C3.83132 5.24642 3.83132 4.61326 4.22185 4.22273Z"
      fill="currentColor"
    />
    <path
      d="M19.7782 4.22258C20.1688 4.6131 20.1688 5.24627 19.7782 5.63679L5.6361 19.7789C5.24558 20.1695 4.61242 20.1694 4.22189 19.7789C3.83137 19.3884 3.83137 18.7552 4.22189 18.3647L18.364 4.22258C18.7546 3.83206 19.3877 3.83206 19.7782 4.22258Z"
      fill="currentColor"
    />
  </svg>
);

export const ThreePoint = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="2.66732" cy="7.99984" r="1.33333" fill="#14151A" />
    <circle cx="7.99935" cy="7.99984" r="1.33333" fill="#14151A" />
    <circle cx="13.3333" cy="7.99984" r="1.33333" fill="#14151A" />
  </svg>
);

export const ExpandArrowDownIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.46967 4.21967C2.17678 4.51256 2.17678 4.98744 2.46967 5.28033L5.46967 8.28033C5.76256 8.57322 6.23743 8.57322 6.53033 8.28033L9.53033 5.28036C9.82322 4.98746 9.82322 4.51259 9.53033 4.2197C9.23744 3.9268 8.76257 3.9268 8.46967 4.21969L6 6.68934L3.53033 4.21967C3.23744 3.92678 2.76256 3.92678 2.46967 4.21967Z"
      fill="currentColor"
    />
  </svg>
);

export const FooterMoreIcon = () => (
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.5 6.5C3.5 7.05228 3.05228 7.5 2.5 7.5C1.94772 7.5 1.5 7.05228 1.5 6.5C1.5 5.94772 1.94772 5.5 2.5 5.5C3.05228 5.5 3.5 5.94772 3.5 6.5Z"
      fill="currentColor"
    />
    <circle cx="6" cy="6.5" r="1" fill="currentColor" />
    <path
      d="M10.5 6.5C10.5 7.05228 10.0523 7.5 9.5 7.5C8.94772 7.5 8.5 7.05228 8.5 6.5C8.5 5.94772 8.94772 5.5 9.5 5.5C10.0523 5.5 10.5 5.94772 10.5 6.5Z"
      fill="currentColor"
    />
  </svg>
);

export const ImgMaskCloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    className="group/imgC"
  >
    <rect
      width="32"
      height="32"
      rx="4"
      fill="white"
      fillOpacity="0.2"
      className="hidden group-hover/imgC:block"
    />
    <path
      d="M5.62946 5.62909C6.15016 5.10839 6.99438 5.10839 7.51507 5.62909L26.3713 24.4853C26.892 25.006 26.892 25.8502 26.3713 26.3709C25.8506 26.8916 25.0063 26.8916 24.4856 26.3709L5.62946 7.51471C5.10876 6.99401 5.10876 6.14979 5.62946 5.62909Z"
      fill="white"
    />
    <path
      d="M26.3716 5.62909C26.8923 6.14979 26.8923 6.99401 26.3716 7.5147L7.51546 26.3709C6.99476 26.8916 6.15055 26.8916 5.62985 26.3709C5.10915 25.8502 5.10915 25.006 5.62985 24.4853L24.486 5.62909C25.0067 5.10839 25.8509 5.10839 26.3716 5.62909Z"
      fill="white"
    />
  </svg>
);
export const ImgMaskRightIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    className="group/imgR cursor-pointer"
  >
    <circle cx="22" cy="22" r="22" fill="#FFFFFF19" className="group-hover/imgR:fill-[#FFFFFF33]" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.8584 15.3069C18.5173 14.5382 19.6747 14.4491 20.4435 15.1081L26.4542 20.2601C26.9877 20.7174 27.2544 21.3587 27.2544 22.0001C27.2544 22.6414 26.9877 23.2827 26.4542 23.74L20.4435 28.892C19.6747 29.551 18.5173 29.4619 17.8584 28.6932C17.1994 27.9244 17.2885 26.767 18.0572 26.1081L22.8499 22.0001L18.0572 17.892C17.2885 17.2331 17.1994 16.0757 17.8584 15.3069Z"
      fill="white"
    />
  </svg>
);
export const ImgMaskLeftIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    className="group/imgL cursor-pointer"
  >
    <circle
      cx="22"
      cy="22"
      r="22"
      transform="rotate(180 22 22)"
      fill="#FFFFFF19"
      className="group-hover/imgL:fill-[#FFFFFF33]"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.1416 28.6931C25.4827 29.4618 24.3253 29.5509 23.5565 28.8919L17.5458 23.7399C17.0123 23.2826 16.7456 22.6413 16.7456 21.9999C16.7456 21.3586 17.0123 20.7173 17.5458 20.26L23.5565 15.108C24.3253 14.449 25.4827 14.5381 26.1416 15.3068C26.8006 16.0756 26.7115 17.233 25.9428 17.8919L21.1501 21.9999L25.9428 26.108C26.7115 26.7669 26.8006 27.9243 26.1416 28.6931Z"
      fill="white"
    />
  </svg>
);
export const ImgMaskDownloadIcon = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.62688 8.20971L9.79354 12.3764L10.5007 13.0835L11.2078 12.3764L15.3744 8.20971L13.9602 6.7955L11.5007 9.25506L11.5007 3.33594H15.5007C16.4211 3.33594 17.1673 4.08213 17.1673 5.0026V15.0026C17.1673 15.9231 16.4211 16.6693 15.5007 16.6693H5.50065C4.58018 16.6693 3.83398 15.9231 3.83398 15.0026V5.0026C3.83398 4.08213 4.58018 3.33594 5.50065 3.33594H9.50065L9.50065 9.25506L7.04109 6.7955L5.62688 8.20971Z"
      fill="var(--col_text00)"
    />
  </svg>
);

export const ShareSelectCheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="8" fill="var(--col_brand02)" />
    <rect
      x="3.75977"
      y="7.64795"
      width="2"
      height="5"
      rx="1"
      transform="rotate(-45 3.75977 7.64795)"
      fill="#222222"
    />
    <rect
      x="10.8301"
      y="4.81982"
      width="2"
      height="7"
      rx="1"
      transform="rotate(45 10.8301 4.81982)"
      fill="#222222"
    />
  </svg>
);

export const ShareSelectUncheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
      fill="currentColor"
    />
  </svg>
);
